import React from "react";
import moment from "moment";

const CalendarActions = {
    SET_DATE: 'SET_DATE',
    SET_SELECTED_UNITS: 'SET_SELECTED_UNITS',
    SET_SEARCH_TEXT: 'SET_SEARCH_TEXT',
    SET_SELECTED_APPOINTMENT: 'SET_SELECTED_APPOINTMENT',
    SET_UNITS: 'SET_UNITS',
    SET_HIDE_DELETED_AND_CANCELLED: 'SET_HIDE_DELETED_AND_CANCELLED',
    REFRESH: 'REFRESH',
}

const defaultFilter = {
    date: moment().utc(),
    selectedUnits: JSON.parse(localStorage.getItem('selected-units')) || [],
    text: '',
    hideDeletedAndCancelled: true
}

const defaultValue = {
    filter: defaultFilter,
    selectedAppointment: { appointmentId: null, patientId: null, unitId: null },
    units: [],
    changedState: 0
}

const CalendarContext = React.createContext(defaultValue);

function calendarReducer(state, action) {
    switch (action.type) {
        case CalendarActions.SET_DATE: {

            return {
                ...state,
                filter: {
                    ...state.filter,
                    date: action.data
                }
            }
        }
        case CalendarActions.SET_SELECTED_UNITS: {
            localStorage.setItem('selected-units', JSON.stringify(action.data))

            return {
                ...state,
                filter: {
                    ...state.filter,
                    selectedUnits: action.data
                }
            }
        }
        case CalendarActions.SET_SELECTED_APPOINTMENT: {

            return {
                ...state,
                selectedAppointment: action.data
            }
        }
        case CalendarActions.SET_SEARCH_TEXT: {

            return {
                ...state,
                filter: {
                    ...state.filter,
                    text: action.data
                }
            }
        }
        case CalendarActions.SET_UNITS: {
            let selected = JSON.parse(localStorage.getItem('selected-units') || '[]')
            if (state?.filter?.selectedUnits?.length === 0) {
                selected = [...action?.data?.map(x => x.id)]
            }
            selected = selected.filter(x => action?.data?.find(y => y.id === x))
            localStorage.setItem('selected-units', JSON.stringify(selected))

            return {
                ...state,
                units: action.data,
                filter: {
                    ...state.filter,
                    selectedUnits: selected
                }
            }
        }
        case CalendarActions.SET_HIDE_DELETED_AND_CANCELLED: {
            return {
                ...state,
                filter: {
                    ...state.filter,
                    hideDeletedAndCancelled: action.data
                }
            }
        }
        case CalendarActions.REFRESH: {
            return {
                ...state,
                changedState: state.changedState + 1
            }
        }
        default: {
            return state;
        }
    }
}

function CalendarProvider({ children }) {
    const [calendar, dispatch] = React.useReducer(calendarReducer, defaultValue);

    const value = { calendar, dispatch };

    return (
        <CalendarContext.Provider value={value}>
            {children}
        </CalendarContext.Provider>
    )
}

function useCalendar() {
    const context = React.useContext(CalendarContext);
    if (!context)
        throw new Error('Calendar Context Error!');

    const { calendar, dispatch } = context;

    const setDate = (date) => {
        dispatch({
            type: CalendarActions.SET_DATE,
            data: date
        })
    }

    const setSelectedUnits = (unitIdList) => {
        dispatch({
            type: CalendarActions.SET_SELECTED_UNITS,
            data: unitIdList
        })
    }

    const setSearchText = (text) => {
        dispatch({
            type: CalendarActions.SET_SEARCH_TEXT,
            data: text
        })
    }

    const setSelectedAppointment = ({ appointmentId, patientId, unitId, checkIn, stateId }) => {
        dispatch({
            type: CalendarActions.SET_SELECTED_APPOINTMENT,
            data: { appointmentId, patientId, unitId, checkIn, stateId }
        })
    }

    const setUnits = (units) => {
        dispatch({
            type: CalendarActions.SET_UNITS,
            data: units
        })
    }

    const refresh = () => {
        dispatch({
            type: CalendarActions.REFRESH,
        })
    }

    const setHideDeletedAndCancelled = (value) => {
        dispatch({
            type: CalendarActions.SET_HIDE_DELETED_AND_CANCELLED,
            data: value
        })
    }

    return {
        filter: calendar.filter,
        selectedAppointment: calendar.selectedAppointment,
        units: calendar.units,
        changedState: calendar.changedState,
        setSelectedAppointment,
        setDate,
        setSearchText,
        setSelectedUnits,
        setUnits,
        setHideDeletedAndCancelled,
        refresh
    }
}

export { CalendarProvider, useCalendar }